import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import { DownOutlined } from '@ant-design/icons';
// import { lock, unlock } from 'static/img/svg/SVGs.js';
import { AccessTypePanel } from './AccessTypePanel';
import {
  isTourPublic,
  // isTourRR,
} from '../../../../../constants/tourAccessibilityTypes.constants';

import { PublicTourIcon, PrivateTourIcon } from '../../components/svg';
import CloseButton from '../../../../Utility/closeButton';

export const AccessTypeWrapper = ({
  tourType,
  rr_type,
  rr_id,
  listCheckedFriends,
  listCheckedClubs,
  tourClubId,
  currentUserId,
  tr,
  mobile,
  editChoose,
  isEditMode,
  imagesLength,
  updateTypes,
  placeType,
}) => {
  const [isVIsible, setVisibility] = useState(false);

  const type = placeType || tourType;

  const showModal = () => {
    setVisibility(true);
    if (!isEditMode) editChoose(true);
  };

  const handleCancel = () => {
    setVisibility(false);
  };

  const iconStyle = {};
  if (isVIsible) {
    iconStyle.fill = '#aa2493';
  }

  const getIcon = (type) =>
    isTourPublic(type) ? (
      <PublicTourIcon width={16} height={16} />
    ) : (
      <PrivateTourIcon width={16} height={16} />
    );

  const getTitle = () => {
    if (rr_type) {
      return rr_type;
    }
    if (isTourPublic(type)) {
      return tr.Public;
    }
    return tr.Private;
  };

  return (
    <div>
      {mobile ? (
        <div
          onClick={showModal}
          className="button-access-tour-type"
          style={iconStyle}
          aria-hidden
        >
          <div className="button-access-tour-type-title">{getTitle()}</div>
          {getIcon(type)}
        </div>
      ) : (
        <Button
          className="acceessibility-tour-dropdown-button"
          onClick={showModal}
          style={iconStyle}
        >
          {getIcon(type)}
          {getTitle()}
          <DownOutlined className="drop-down-icon" />
        </Button>
      )}
      <Modal
        closable={false}
        header={false}
        footer={false}
        className="access-tour-type-wrapper"
        visible={isVIsible}
        width={310}
        maskStyle={{ background: 'transparent' }}
      >
        <AccessTypePanel
          rr_type={rr_type}
          rr_id={rr_id}
          tourType={type}
          listCheckedFriends={listCheckedFriends}
          listCheckedClubs={listCheckedClubs}
          tourClubId={tourClubId}
          updateTypes={updateTypes}
          currentUserId={currentUserId}
          language={tr}
          setVisibility={setVisibility}
          publicAvailable={imagesLength}
          placeType={placeType}
        />
        <CloseButton close={handleCancel} />
      </Modal>
    </div>
  );
};
